import { Grid2 } from '@mui/material';
import styled from 'styled-components';

export const ResourceDetailItemContainer = styled(Grid2)`
  && {
    padding: 1rem 1.5rem;

    .custom-tag {
      align-self: flex-start;
    }
  }
`;
